// extracted by mini-css-extract-plugin
export default {"graphContentWrapper":"DemographicGraphCard_graphContentWrapper__s+TxV","graphRowWrapper":"DemographicGraphCard_graphRowWrapper__aKpyN"};